import { createAction } from '@gef-ui/utils/fsaActions';
import { temporaryStoreActions } from '../../constants';
const updateData = (path, data)=>({
        path,
        data
    });
/**
 * update temporary store
 *
 * @documented
 * @category Action
 * @example
 *
 * 	updateTemporaryStore('temporaryFormData', 'Ahoj')
 *
 */ export const updateTemporaryStore = createAction(temporaryStoreActions.UPDATE_TEMPORARY_STORE, updateData);
/**
 * delete temporary store
 *
 * @documented
 * @category Action
 * @example
 *
 * 	deleteTemporaryStore('temporaryFormData')
 *
 */ export const deleteTemporaryStore = createAction(temporaryStoreActions.DELETE_TEMPORARY_STORE, (payload)=>({
        path: payload
    }));
/**
 * clear temporary store and sets initial store
 *
 * @documented
 * @category Action
 * @example
 *
 * 	clearTemporaryStore('temporaryFormData')
 *
 */ export const clearTemporaryStore = createAction(temporaryStoreActions.CLEAR_TEMPORARY_STORE);
